import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import useDocumentMeta from '@/hooks/useDocumentMeta';

export default function NotFound() {
  useDocumentMeta({
    title: '页面不存在 - 妖精视频',
    description: '你访问的页面不存在或已被移除，请返回妖精视频首页或从分类频道继续浏览影视内容。',
    keywords: '妖精视频,404,页面不存在',
  });

  return (
    <SiteLayout>
      <section className="w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
        <span className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-50 text-4xl text-primary-500">
          <i className="ri-film-line"></i>
        </span>
        <h1 className="mt-6 font-heading text-5xl md:text-6xl font-extrabold text-foreground-950">404</h1>
        <h2 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-900">
          这个页面走丢了
        </h2>
        <p className="mt-3 max-w-lg text-sm md:text-base leading-relaxed text-foreground-600">
          你访问的页面不存在或已被移除。别担心，回到首页或从下面的分类继续探索精彩影视内容吧。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览电影
          </Link>
          <Link
            to="/category/tv"
            className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览电视剧
          </Link>
          <Link
            to="/category/variety"
            className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览综艺
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}